/* eslint-disable import-x/no-namespace */

import { createFastFilterDateLabel } from '@vlabs/monokit/shared/lib/fast-filter-date-label';
import { FastFilterGroup } from '@vlabs/monokit/shared/ui/fast-filter-group';

import * as fastFilters from './fast-filters';
import { usePermissionTagsFilters } from './usePermissionTagsFilters';

export function PermissionTagListFastFilters(): JSX.Element {
  const { filters, updateFilters } = usePermissionTagsFilters();

  return (
    <FastFilterGroup>
      {!!filters.created_by_user && (
        <fastFilters.UserIdFilterWithBottomPopover
          onClear={() => updateFilters({ created_by_user: undefined })}
          value={filters.created_by_user}
        />
      )}
      {!!(filters.create_time__gte ?? filters.create_time__lt) && (
        <fastFilters.DateFilterWithBottomPopover
          onClear={() => updateFilters({ create_time__gte: undefined, create_time__lt: undefined })}
          value={createFastFilterDateLabel({
            createTimeGte: filters.create_time__gte,
            createTimeLt: filters.create_time__lt,
          })}
        />
      )}
    </FastFilterGroup>
  );
}
